/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardsLimitsTraitDTO
 */
export interface DashboardsLimitsTraitDTO {
    /**
     * 
     * @type {number}
     * @memberof DashboardsLimitsTraitDTO
     */
    maxDashboardsPerProject?: number;
}

/**
 * Check if a given object implements the DashboardsLimitsTraitDTO interface.
 */
export function instanceOfDashboardsLimitsTraitDTO(value: object): value is DashboardsLimitsTraitDTO {
    return true;
}

export function DashboardsLimitsTraitDTOFromJSON(json: any): DashboardsLimitsTraitDTO {
    return DashboardsLimitsTraitDTOFromJSONTyped(json, false);
}

export function DashboardsLimitsTraitDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardsLimitsTraitDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'maxDashboardsPerProject': json['maxDashboardsPerProject'] == null ? undefined : json['maxDashboardsPerProject'],
    };
}

export function DashboardsLimitsTraitDTOToJSON(value?: DashboardsLimitsTraitDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'maxDashboardsPerProject': value['maxDashboardsPerProject'],
    };
}

